<template>
  <div>
    <v-toolbar class="primary elevation-0 small-extension" dark>
      <h1 class="titulo">Configurações</h1>
    </v-toolbar>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5 configuracoes-form-start">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12 class="text-xs-center">
                <img :src="imageSrc" class="avatar" style="border-color: #F37021; width: 150px; height: 150px; display: inline-block;">
                <label class="subheading secondary--text mt-2 mb-4" style="text-transform: uppercase; width: 100%; float: left; cursor: pointer;">
                  Trocar foto
                  <input type="file" accept="image/*" ref="fileInput" @change="onFileChange" style="display: none;">
                </label>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="visualizacoes"
                  v-model="form.fields.visualizacao"
                  label="Modo de visualização padrão"
                  v-validate="'required'"
                  name="visualizacao"
                  data-vv-as="visualização padrão"
                  :error-messages="errors.has('visualizacao') ? errors.first('visualizacao') : []"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.name"
                  label="Nome"
                  v-validate="'required'"
                  name="name"
                  data-vv-as="nome"
                  :error-messages="errors.has('name') ? errors.first('name') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.cargo"
                  label="Cargo"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.celular"
                  label="Celular"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 class="my-2">
                <strong>Login</strong><br>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  v-model="form.fields.email"
                  label="E-mail"
                  v-validate="'required|email'"
                  name="email"
                  data-vv-as="email"
                  :error-messages="errors.has('email') ? errors.first('email') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  type="password"
                  v-model="form.fields.password"
                  label="Senha (opcional)"
                  v-validate="'min:6'"
                  name="password"
                  data-vv-as="senha"
                  :error-messages="errors.has('password') ? errors.first('password') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  autocomplete="off"
                  type="password"
                  v-model="form.fields.conf_password"
                  label="Confirmar senha"
                  v-validate="'min:6|confirmed:password'"
                  name="conf_password"
                  data-vv-as="confirmação de senha"
                  :error-messages="errors.has('conf_password') ? errors.first('conf_password') : []"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row justify-center class="text-xs-center mt-4">
              <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
                <v-btn type="submit" outline block large class="secondary secondary--text ma-0" :disabled="isFormInvalid">
                  Salvar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import ImageTools from '@/components/Utils/resizeBeforeUpload'

  export default {
    data () {
      return {
        imageSrc: 'static/default.jpg',
        niveis: ['Administrador', 'Patrimônio', 'Operacional'],
        visualizacoes: [{ text: 'Lista', value: 'lista' }, { text: 'Mapa', value: 'mapa' }],
        form: {
          fields: {
            visualizacao: '',
            avatar: null,
            name: '',
            cargo: '',
            celular: '',
            email: '',
            password: '',
            conf_password: ''
          }
        }
      }
    },
    mounted () {
      this.$store.dispatch('utils/showLoading')
      axios.get(`${apiURL}/my/profile`).then((response) => {
        const data = response.data.data

        this.imageSrc = data.avatar
        this.form.fields.visualizacao = data.visualizacao
        this.form.fields.name = data.name
        this.form.fields.cargo = data.cargo
        this.form.fields.celular = data.celular
        this.form.fields.email = data.email

        this.$store.dispatch('utils/hideLoading')
      }, () => {
        this.$store.dispatch('utils/showSnackbar', {
          text: 'Servidor indisponível. Tente novamente mais tarde.',
          persistent: true
        })
        this.$store.dispatch('utils/hideLoading')
      })
    },
    computed: {
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    methods: {
      onFileChange (event) {
        const input = event.target

        if (input.files && input.files[0]) {
          const reader = new FileReader()

          reader.onload = (e) => {
            this.imageSrc = e.target.result
          }

          reader.readAsDataURL(input.files[0])
          this.form.fields.avatar = input.files[0]
        }
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            const formData = new FormData()

            Object.keys(this.form.fields).forEach((key) => {
              if (key !== 'avatar') {
                formData.append(key, this.form.fields[key])
              }
            })

            if (this.form.fields.avatar !== null) {
              ImageTools.resize(this.form.fields['avatar'], {
                width: 300,
                height: 300
              }, (blob, didItResize) => {
                formData.append('avatar', blob)

                axios.post(`${apiURL}/my/profile`, formData).then((response) => {
                  this.$auth.fetch()
                  this.$store.dispatch('utils/showSnackbar', {
                    persistent: true,
                    type: 'success',
                    text: 'Suas configurações foram alteradas com sucesso!'
                  })
                  this.$store.dispatch('utils/hideLoading')
                  this.$router.push('/')
                }, (error) => {
                  let errorText = ''
                  if (error.response.status === 422) {
                    errorText = 'E-mail já cadastrado. Por favor, escolha outro.'
                  } else {
                    errorText = 'Servidor indisponível. Tente novamente mais tarde.'
                  }
                  this.$store.dispatch('utils/showSnackbar', {
                    text: errorText
                  })
                  this.$store.dispatch('utils/hideLoading')
                })
              })
            } else {
              axios.post(`${apiURL}/my/profile`, formData).then((response) => {
                this.$auth.fetch()
                this.$store.dispatch('utils/showSnackbar', {
                  persistent: true,
                  type: 'success',
                  text: 'Suas configurações foram alteradas com sucesso!'
                })
                this.$store.dispatch('utils/hideLoading')
                this.$router.push('/')
              }, (error) => {
                let errorText = ''
                if (error.response.status === 422) {
                  errorText = 'E-mail já cadastrado. Por favor, escolha outro.'
                } else {
                  errorText = 'Servidor indisponível. Tente novamente mais tarde.'
                }
                this.$store.dispatch('utils/showSnackbar', {
                  text: errorText
                })
                this.$store.dispatch('utils/hideLoading')
              })
            }
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>

<style scoped>
@media (max-width: 599px) {
  .configuracoes-form-start {
    padding-top: 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// UsuariosConfiguracoes.vue?30c3aa6e